import { render, staticRenderFns } from "./EstimateTemplates.vue?vue&type=template&id=04bcd7bd&scoped=true"
import script from "./EstimateTemplates.vue?vue&type=script&lang=js"
export * from "./EstimateTemplates.vue?vue&type=script&lang=js"
import style0 from "./EstimateTemplates.vue?vue&type=style&index=0&id=04bcd7bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bcd7bd",
  null
  
)

export default component.exports